import { useContext, useState } from "react";

import { ThemeContext } from "../Helper/Context";

const Notification = () => {
  const { mainState, setShowNotification } = useContext(ThemeContext);
  return (
    <div className="notification">
      <div className="heading">
        <i className="fas fa-exclamation-circle"></i> <h3>Before You Begin</h3>
      </div>
      <div className="closebtn" onClick={(e) => setShowNotification(false)}>
        <i className="fal fa-times"></i>
      </div>
      {!mainState.isLoggedIn && (
        <>
          {/* <p>
            Your Swim ARCademy membership will be $19 per week which includes your lesson, 2 spectators and access to the pools outside class time.
          </p> */}
          <p>
            Please view our <a href="https://www.cockburnarc.com.au/About/Terms-and-Conditions">terms and conditions</a> for full details.{" "}
          </p>
        </>
      )}
      {mainState.isLoggedIn && (
        <>
          <p>Your place in the class will be confirmed once you have provided your payment details. </p>
          <p>Then your first class will be in the next 7 days.</p>
          <p>
            <a href="/">View full terms and conditions here</a>
          </p>
        </>
      )}
    </div>
  );
};

export default Notification;
